import select from 'dom-select';
import { serialize } from 'dom-form-serializer/dist/dom-form-serializer';
import serializeJSON from 'es-serialize-json';
import snakeToCamel from '@lib/snakeToCamel';

export default (el) => {
  const ui = {
    el,
    form: select('.filter-deck__form', el),
    filterGroups: select.all('[id$="-filters"]', el),
    filters: select.all('.filter-deck__filter input', el),
    listParent: select('.filter-deck__body', el),
    loadMoreBtn: select('.btn--load-more', el),
    filtersReset: select.all('.filters-reset', el)
  };

  // if we're not filterable, bail early
  if (!ui.filters) {
    return;
  }

  ui.cards = el.dataset.itemSelector ? select.all(`${el.dataset.itemSelector}`, el) : select.all('.card', el);
  // optional messaging and data options that might come from CMS
  ui.nopeMsg = ui.el && ui.el.dataset.nullMessage ? ui.el.dataset.nullMessage : 'There are no results matching your choices.';
  ui.resetMsg = ui.el && ui.el.dataset.resetMsg ? ui.el.dataset.resetMsg : 'Clear Filters';
  ui.dataSep = ui.el && ui.el.dataset.separator ? ui.el.dataset.separator : '|';

  const state = {
    filter: null,
    filterNames: ui.filters.map((filter) => filter.name),
    initialSet: ui.listParent && ui.listParent.dataset.initialLimit ? parseInt(ui.listParent.dataset.initialLimit) : 8,  // eslint-disable-line
    cardsVisible: ui.listParent && ui.listParent.dataset.initialLimit ? parseInt(ui.listParent.dataset.initialLimit) : 8,  // eslint-disable-line
    resultsPage: 0
  };

  function getCurrentSet() {
    const shownCards = select.all('.filter-item:not(.filtered--hide)', ui.el);

    return shownCards;
  }

  function getCardsVisible() {
    const shownCards = getCurrentSet();
    state.cardsVisible = shownCards.length;

    return state.cardsVisible;
  }

  function showLoadMore() {
    return ui.loadMoreBtn && ui.loadMoreBtn.classList.remove('is-hidden');
  }

  function hideLoadMore() {
    return ui.loadMoreBtn && ui.loadMoreBtn.classList.add('is-hidden');
  }

  function toggleLoadMore(set) {
    const visibleCards = getCardsVisible();

    if (set.length > visibleCards) {
      showLoadMore();
    } else {
      hideLoadMore();
    }

    return set;
  }

  // not using reset() because it doesn't trigger change event
  function resetFilters(ev) {
    ev.preventDefault();

    ui.filters.forEach((filter) => {
      filter.checked = false; // eslint-disable-line
    });

    ev.target.blur();

    state.resultsPage = 0;
  }

  function updateFilterState() {
    const filterStr = serialize(ui.form);
    const encodedFilterStr = serializeJSON(filterStr);
    state.filter = `${encodedFilterStr}`;
  }

  function showCard(card) {
    card.classList.add('filtered--show');
    card.classList.remove('filtered--hide');

    card.setAttribute('aria-hidden', false);
    return card;
  }

  function hideCard(card) {
    card.classList.remove('filtered--show');
    card.classList.add('filtered--hide');

    card.setAttribute('aria-hidden', true);
    return card;
  }

  function hideAllCards() {
    ui.cards.forEach((card) => {
      hideCard(card);
    });
  }

  function showAllCards() {
    ui.cards.forEach((card) => {
      showCard(card);
    });
  }

  function hideExtraCards(set) {
    const curSet = getCurrentSet();

    // hide all cards past current page
    curSet.forEach((card, index) => {
      if (index > ((state.initialSet) * (state.resultsPage + 1)) - 1) {
        hideCard(card);
      }
    });

    const curVisible = getCardsVisible();

    console.log(set.length, {curVisible}, set.length > curVisible);
    if (set.length > curVisible) {
      showLoadMore();
    } else {
      hideLoadMore();
    }
  }

  function notSorry() {
    const nope = select('.nope', ui.listParent);

    if (nope) {
      ui.listParent.removeChild(nope);
    }
  }

  function handleReset(ev) {
    resetFilters(ev);
    showAllCards();
    ui.el.dispatchEvent(new CustomEvent('setFiltered', {
      bubbles: true,
      detail: { hiddenSet: [] }
    }));
    hideExtraCards(ui.cards);
    toggleLoadMore(ui.cards);
    updateFilterState();
    notSorry();
    ui.el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    state.resultsPage = 0;
  }

  function saySorry() {
    const wrap = document.createElement('div');
    const nope = document.createElement('h3');
    const msg = document.createTextNode(ui.nopeMsg);
    const reset = document.createElement('button');
    const resetMsg = document.createTextNode(ui.resetMsg);

    wrap.classList.add('text--align-center', 'nope', 'rhythm--large');

    nope.classList.add('nope__msg', 'heading', 'heading--h3');
    nope.appendChild(msg);

    reset.classList.add('button', 'button--outlined', 'filters-reset', 'nope__button');
    reset.appendChild(resetMsg);

    wrap.appendChild(nope);
    wrap.appendChild(reset);

    notSorry();
    ui.listParent.appendChild(wrap);
    hideLoadMore();
    reset.addEventListener('click', handleReset);
  }

  // converts filter name to data attribute
  function nameToDataset(attr) {
    const name = attr.split('.')[0];

    return snakeToCamel(name);
  }

  // pulls filter value from its name atribute
  function nameToValue(attr) {
    return attr.split('.')[1];
  }

  // filters an object to only items that aren't null
  function trueObj(obj) {
    return Object.keys(obj).reduce((acc, cv) => {
      if (obj[cv]) {
        acc[cv] = obj[cv]; // eslint-disable-line
      }

      return acc;
    }, {});
  }

  // create object of arrays of inputs by group
  function filterGroupsInputObj() {
    const output = {};

    // loop over groups, find inputs in group,
    // push to array in output object
    ui.filterGroups.forEach((group) => {
      const id = group.id.split('-filters')[0];
      const inputs = select.all('.input', group);

      output[id] = inputs;

      return output;
    });

    return output;
  }

  // sort selected inputs by existing filter groups
  function groupedSelectedinputs(groupObj, groupArr, allSelected) {
    // loop groups
    const filteredGroup = groupArr.map((group) => {
      // get inner array of inputs
      const innerArr = groupObj[group];
      // find selected inputs among groups
      const filteredSel = innerArr.filter((item) => allSelected.includes(item.id));

      return filteredSel;
    });

    // get rid of empty arrays
    const selectedGroups = filteredGroup.filter((fg) => fg.length > 0);

    return selectedGroups;
  }

  // where the actual filtering happens
  function handleChange() {
    const filterObject = serialize(ui.form); // { name: value }
    const selectedFilters = trueObj(filterObject);

    // if nothing's selected, reset & bail
    if (Object.keys(selectedFilters).length === 0 && selectedFilters.constructor === Object) {
      notSorry();
      showAllCards();
      hideExtraCards(ui.cards);
      ui.el.dispatchEvent(new CustomEvent('setFiltered', {
        bubbles: true,
        detail: { hiddenSet: [] }
      }));
      return;
    }

    const filterKeysArray = Object.keys(selectedFilters); // array of selected names
    const groupedInputs = filterGroupsInputObj();
    const groupArr = Object.keys(groupedInputs);
    const selectedGroups = groupedSelectedinputs(groupedInputs, groupArr, filterKeysArray);

    // create array to push cards into
    const groupCards = [];

    // hide all cards
    // then loop over them and see which match selected filters by group
    ui.cards
      .map((card) => hideCard(card)).forEach((card) => {
        // loop over selected inputs by group
        // selectedGroups is an array of arrays
        for (let index = 0; index < selectedGroups.length; index++) {
          // if this group's results array doesn't yet exist, create it
          if (groupCards[index] == null) {
            groupCards[index] = [];
          }

          // get this group's array of selected inputs...
          const innerSelected = selectedGroups[index];

          // ...and loop over it
          innerSelected.forEach((input) => {
            // create a data attribute based off input
            const dataAttrName = nameToDataset(input.name);
            const filterValue = nameToValue(input.name);
            // retrieve card value based on data attribute
            const cardValue = card.dataset[dataAttrName] ? card.dataset[dataAttrName].toLowerCase() : '';
            // allow for multiple values on a single card
            // per filter (eg, data-language="spanish|english")
            const valueArr = cardValue.split(ui.dataSep);
            // test if values match, ie card is in selected filter
            const yepnope = valueArr.filter((value) => value === filterValue);

            // if card matches, push it into this group's array
            if (yepnope.length > 0 || filterValue === 'all') {
              groupCards[index].push(card);
            }
          });
        }
      });

    // find cards common to all three group arrays
    // eslint-disable-next-line max-len
    const commonCards = groupCards.shift().filter((group) => groupCards.every((card) => card.indexOf(group) !== -1));

    const getHiddenCards = () => {
      const unique1 = ui.cards.filter((c) => commonCards.indexOf(c) === -1);
      const unique2 = commonCards.filter((c) => ui.cards.indexOf(c) === -1);
      const uncommonCards = unique1.concat(unique2);

      return uncommonCards;
    };

    // ensure we have matching cards and show them
    if (commonCards.length > 0) {
      notSorry();
      commonCards.map((card) => showCard(card));
      hideExtraCards(commonCards);
      ui.el.dispatchEvent(new CustomEvent('setFiltered', {
        bubbles: true,
        detail: { hiddenSet: getHiddenCards() }
      }));
    } else {
      hideAllCards();
      saySorry();
    }
  }

  function handleOnClick(ev) {
    ev.preventDefault();
    ev.target.blur();

    state.resultsPage += 1;

    handleChange();
  }

  function bindEvents() {
    // bind filter change event
    ui.filters.forEach((filter) => {
      filter.addEventListener('change', (ev) => {
        state.resultsPage = 0;
        handleChange(ev);
      });
    });

    if (ui.loadMoreBtn) {
      ui.loadMoreBtn.addEventListener('click', handleOnClick);
    }

    if (ui.filtersReset) {
      ui.filtersReset.forEach((rf) => {
        rf.addEventListener('click', handleReset);
      });
    }
  }

  function init() {
    bindEvents();
    hideExtraCards(ui.cards);
  }

  init();
};
